import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { HS_ConsequenceRequest } from "./HS_ConsequenceRequest";

@Injectable()
export class DataService_HallSweepConsequence {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	ConsequenceSelectList() {
		var postResult$ = new Subject();
		var url = "HallSweep/ConsequenceSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ConsequenceExistsSelect(ConsequenceID, ConsequenceTrigger) {
		var postResult$ = new Subject();
		var url = "HallSweep/ConsequenceExistsSelect?ConsequenceID=" + ConsequenceID + "&ConsequenceTrigger=" + ConsequenceTrigger;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ConsequenceInsert(parms: HS_ConsequenceRequest) {
		var postResult$ = new Subject();
		var url = "HallSweep/ConsequenceInsert";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ConsequenceUpdate(parms: HS_ConsequenceRequest) {
		var postResult$ = new Subject();
		var url = "HallSweep/ConsequenceUpdate";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ConsequenceToggle(ConsequenceID, Active) {
		var postResult$ = new Subject();
		var url = "HallSweep/ConsequenceToggle?ConsequenceID=" + ConsequenceID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ConsequenceInUse(ConsequenceID) {
		var postResult$ = new Subject();
		var url = "HallSweep/ConsequenceInUse?ConsequenceID=" + ConsequenceID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ConsequenceDelete(ConsequenceID) {
		var postResult$ = new Subject();
		var url = "HallSweep/ConsequenceDelete?ConsequenceID=" + ConsequenceID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
